import request from '@/utils/admin/request'

export function getCreditList(param) {
    return request({
        url: '/charge-analysis/credit-list',
        method: 'get',
        params: param
    });
}

export function getStatisticSaleReturn(param) {
    return request({
        url: '/c/product/statistic-sale-return',
        method: 'get',
        params: param
    });
}

export function getSaleSumNum(param) {
    return request({
        url: '/charge-analysis/page-sale-sum-num',
        method: 'get',
        params: param
    });
}

export function getProductCheck(param) {
    return request({
        url: '/charge-analysis/analysis-product-check',
        method: 'get',
        params: param
    });
}

export function getProductCheckByFactory(param) {
    return request({
        url: '/charge-analysis/analysis-product-check-factory',
        method: 'get',
        params: param
    });
}

export function getProductProfit(param) {
    return request({
        url: '/charge-analysis/analysis-profit',
        method: 'get',
        params: param
    });
}

export function getProductProfitFactory(param) {
    return request({
        url: '/charge-analysis/analysis-profit-factory',
        method: 'get',
        params: param
    });
}

export function getProductProfitUser(param) {
    return request({
        url: '/charge-analysis/analysis-profit-user',
        method: 'get',
        params: param
    });
}

